/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc template/datepicker/popup.html
 *
 * @description
 * override default datepicker template
 */
angular.module("template/datepicker/popup.html")
  .run(["$templateCache", function($templateCache) {
    $templateCache.put("template/datepicker/popup.html",
      "<ul class=\"dropdown-menu\" ng-style=\"{display: (isOpen && 'block') || 'none', top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\">\n" +
      " <li ng-transclude></li>\n" +
      " <li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
      "   <span class=\"btn-group pull-left\">\n" +
      "     <button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"select('today')\">{{ getText('current') }}</button>\n" +
      "     <button type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
      "   </span>\n" +
      "   <button type=\"button\" class=\"btn btn-sm btn-primary pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
      " </li>\n" +
      "</ul>\n" +
      "");
  }]);
  
})();
